module.exports = "<div class=\"left-nav\">\n  <tog-left-nav-item *ngFor=\"let feature of features\"\n                    [feature]=\"feature\"\n                    (click)=\"navigate(feature)\">\n  </tog-left-nav-item>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /app/src/app/shared/components/left-nav/left-nav.template.html
// module id = ../../../../../src/app/shared/components/left-nav/left-nav.template.html
// module chunks = 12